module.exports = __webpack_public_path__ + "media/images/categories/perceptive-31ecb6573b1fe8ca2df5aad983b6b444.png";